import { Component, JSX, Show } from "solid-js";

export const FormLabel: Component<JSX.LabelHTMLAttributes<HTMLLabelElement>> = (
  props
) => {
  return (
    <Show when={props.children}>
      <label {...props} class={props.class ?? "form-label"} />
    </Show>
  );
};
export default FormLabel;
